'use client';
import { useMachine, normalizeProps } from '@zag-js/react';
import * as select from '@zag-js/select';
import { useMemo, useId } from 'react';
import { createSplitProps } from '../create-split-props.mjs';
import '../environment/index.mjs';
import { useEvent } from '../use-event.mjs';
import { useEnvironmentContext } from '../environment/environment-context.mjs';

const useSelect = (props) => {
  const [collectionOptions, rest] = createSplitProps()(props, [
    "isItemDisabled",
    "itemToValue",
    "itemToString",
    "items"
  ]);
  const collection = useMemo(
    () => select.collection(collectionOptions),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(collectionOptions)
  );
  const initialContext = {
    id: useId(),
    getRootNode: useEnvironmentContext(),
    collection,
    ...rest,
    value: props.defaultValue
  };
  const context = {
    ...initialContext,
    collection,
    value: props.value,
    onValueChange: useEvent(props.onValueChange, { sync: true }),
    onHighlightChange: useEvent(props.onHighlightChange),
    onOpenChange: useEvent(props.onOpenChange)
  };
  const [state, send] = useMachine(select.machine(initialContext), {
    context
  });
  return select.connect(state, send, normalizeProps);
};

export { useSelect };
